import axiosInstance from "@/api/axiosInstance";

export interface ActiveInquiry {
  id: number;
  publicReference: string;
  area: string;
  from: string;
  to: string;
  status: string;
  lastModification: string;
}

export interface UpcomingStay {
  publicReference: string;
  accommodation: string;
  startDate: string;
  endDate: string;
  numberOfPeople: number;
  costCenterName: string;
}

export interface CustomerDashboardStats {
  pendingOffersCount: number;
  activeBookingsCount: number;
  upcomingStaysCount: number;
  allActiveInquiriesCount: number;
  activeInquiries: ActiveInquiry[];
  upcomingStays: UpcomingStay[];
  companyUsersCount: number | null;
  companyCostCentersCount: number | null;
}

export interface LatestInquiry {
  id: number;
  publicReference: string;
  companyName: string;
  userEmail: string;
  area: string;
  from: string;
  to: string;
  status: string;
  createdAt: string;
}

export interface UpcomingCheckIn {
  publicReference: string;
  accommodation: string;
  startDate: string;
  guestCount: number;
}

export interface AdminDashboardStats {
  newInquiriesCount: number;
  offersSentCount: number;
  acceptedOffersCount: number;
  activeBookingsCount: number;
  overdueBillsCount: number;
  latestInquiries: LatestInquiry[];
  upcomingCheckIns: UpcomingCheckIn[];
}

export class DashboardService {
  public async getCustomerStats(): Promise<CustomerDashboardStats> {
    const response = await axiosInstance.get("/api/v1/dashboard/stats");
    return response.data;
  }

  public async getAdminStats(): Promise<AdminDashboardStats> {
    const response = await axiosInstance.get("/api/v1/admin/dashboard/stats");
    return response.data;
  }
}
